import { render, staticRenderFns } from "./TheProfileSubscriptions.vue?vue&type=template&id=193a13cf&"
import script from "./TheProfileSubscriptions.vue?vue&type=script&lang=js&"
export * from "./TheProfileSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileSubscriptions.vue?vue&type=style&index=0&id=193a13cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports